export const APPOINTMENTS = 'APPOINTMENTS';
export const APPOINTMENT_ERROR = 'APPOINTMENT_ERROR';
export const LANDING = 'LANDING';
export const MODAL = 'MODAL';
export const ADD_CUSTOMER = 'CREATE_CUSTOMER';
export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
export const CUSTOMER_ERROR = 'CUSTOMER_ERROR';
